export function parseAlertString(alertString: string): {
  title: string
  text: string
} {
  const [title, text] = alertString.split('|')
  return {
    title: title.trim(), // Убираем пробелы вокруг текста
    text: text.trim(), // Убираем пробелы вокруг текста
  }
}
